import { HvlDateConverter } from '@hvlng/framework-bff/util';
import { JsonObject, JsonProperty } from 'json2typescript';
import { EmptyControl, MaxLength, Required } from '@hvlng/framework-bff/core';

import { EnumGender } from './enum-gender';
import { EnumIdentityStatus } from './enum-identity-status';
import { MasterDataModel } from './master-data-model';

@JsonObject('KovanHrPerIdentityModel')
export class PerIdentityModel extends MasterDataModel {
    @MaxLength(15)
    @Required()
    @JsonProperty('identificationNumber', String, true)
    identificationNumber: string = null;

    @MaxLength(50)
    @Required()
    @JsonProperty('name', String, true)
    name: string = null;

    @MaxLength(50)
    @Required()
    @JsonProperty('surname', String, true)
    surname: string = null;

    @MaxLength(50)
    @JsonProperty('maidenName', String, true)
    maidenName: string = null;

    @MaxLength(50)
    @JsonProperty('fatherName', String, true)
    fatherName: string = null;

    @MaxLength(50)
    @JsonProperty('motherName', String, true)
    motherName: string = null;

    @EmptyControl()
    @JsonProperty('birthDate', HvlDateConverter, true)
    birthDate: Date = null;

    @MaxLength(100)
    @JsonProperty('placeOfBirth', String, true)
    placeOfBirth: string = null;

    @EmptyControl()
    @JsonProperty('gender', String, true)
    gender: EnumGender = null;

    @MaxLength(255)
    @JsonProperty('hrmMaritalStatusUuid', String, true)
    hrmMaritalStatusUuid: string = null;

    @EmptyControl()
    @Required()
    @JsonProperty('genCountryId', Number, true)
    genCountryId: number = null;

    @EmptyControl()
    @JsonProperty('genProvinceId', Number, true)
    genProvinceId: number = null;

    @EmptyControl()
    @JsonProperty('genSubprovinceId', Number, true)
    genSubprovinceId: number = null;

    @MaxLength(50)
    @JsonProperty('subdistrictVillage', String, true)
    subdistrictVillage: string = null;

    @MaxLength(10)
    @JsonProperty('volumeNumber', String, true)
    volumeNumber: string = null;

    @MaxLength(10)
    @JsonProperty('familyOrder', String, true)
    familyOrder: string = null;

    @MaxLength(10)
    @JsonProperty('orderNumber', String, true)
    orderNumber: string = null;

    @MaxLength(50)
    @JsonProperty('placeOfIssue', String, true)
    placeOfIssue: string = null;

    @MaxLength(10)
    @JsonProperty('registrationNumber', String, true)
    registrationNumber: string = null;

    @EmptyControl()
    @JsonProperty('dateOfIssue', HvlDateConverter, true)
    dateOfIssue: Date = null;

    @EmptyControl()
    @JsonProperty('validUntil', HvlDateConverter, true)
    validUntil: Date = null;

    @MaxLength(12)
    @JsonProperty('identitySerial', String, true)
    identitySerial: string = null;

    @MaxLength(12)
    @JsonProperty('identitySerialNumber', String, true)
    identitySerialNumber: string = null;

    @EmptyControl()
    @JsonProperty('identityStatus', String, true)
    identityStatus: EnumIdentityStatus = null;

    @EmptyControl()
    @JsonProperty('reasonOfIssueId', Number, true)
    reasonOfIssueId: number = null;

    @EmptyControl()
    @JsonProperty('status', String, true)
    status: string = null;

    @EmptyControl()
    @JsonProperty('bloodType', String, true)
    bloodType: string = null;

    @EmptyControl()
    @JsonProperty('integrationSourceId', Number, true)
    integrationSourceId: number = null;

    @EmptyControl()
    @JsonProperty('integrationGetDate', HvlDateConverter, true)
    integrationGetDate: Date = null;

    @EmptyControl()
    @JsonProperty('deathDate', HvlDateConverter, true)
    deathDate: Date = null;

    @EmptyControl()
    @JsonProperty('hitapAuthLevelId', Number, true)
    hitapAuthLevelId: number = null;

    @EmptyControl()
    @JsonProperty('explanation', String, true)
    explanation: string = null;
}
